<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.local_locations">
  <div class="row">
    <div class="dropdown_div col-4 label_right">
      <app-label
        [Text]="localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryCode(CtryCode,'v8'))"
        [IsMandatory]="false"></app-label>
    </div>
    <div class="select_dropdown col-8">
      <ngx-select id="{{elementIds.state}}" *ngIf="states" [(ngModel)]="locations.v3" [optionValueField]="'key'"
        [optionTextField]="'s_value'" [items]="states" (select)="onLocationChanged(1)"
        placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryCode(CtryCode,'v8'))}}">
        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
          <div [ngClass]="localService.selectedLanguageCode + '_medium'">
            {{option.data.value}}
          </div>
        </ng-template>
      </ngx-select>
    </div>
  </div>
  <div class="row">
    <div class="dropdown_div col-4 label_right">
      <app-label [Text]="localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryCode(CtryCode,'v9'))" [IsMandatory]="false"></app-label>
    </div>
    <div class="select_dropdown col-8">
      <ngx-select id="{{elementIds.district}}" *ngIf="districts" [(ngModel)]="locations.v2" [optionValueField]="'key'"
        [optionTextField]="'s_value'" [items]="districts" (select)="onLocationChanged(2)"
        placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryCode(CtryCode,'v9'))}}">
        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
          <div [ngClass]="localService.selectedLanguageCode + '_medium'">
            {{option.data.value}}
          </div>
        </ng-template>
      </ngx-select>
    </div>
  </div>
  <div class="row">
    <div class="dropdown_div col-4 label_right">
      <app-label [Text]="localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryCode(CtryCode,'v10'))" [IsMandatory]="false"></app-label>
    </div>
    <div class="select_dropdown col-8">
      <ngx-select id="{{elementIds.constituency}}" *ngIf="constituencies" [(ngModel)]="locations.v1"
        [optionValueField]="'key'" [optionTextField]="'s_value'" [items]="constituencies"
        (select)="onLocationChanged(3)"
        placeholder="{{localService.getText(localService.countryLocationLevels,localService.getLocationLevelByCountryCode(CtryCode,'v10'))}}">
        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
          <div [ngClass]="localService.selectedLanguageCode + '_medium'">
            {{option.data.value}}
          </div>
        </ng-template>
      </ngx-select>
    </div>
  </div>
</div>
<span style="display:none;">
  <input type="button" class="on_language_changed" (click)="onLanguageChanged()" />
</span>